import React, { useState } from 'react';
import { ExternalLink, ArrowUpRight } from 'lucide-react';
import ProjectModal from './ProjectModal';

const Portfolio = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openProjectModal = (project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedProject(null), 300);
  };
  const projects = [
    {
      name: 'Mylan Project',
      type: 'Commercial Office',
      location: 'Bangalore',
      image: 'https://customer-assets.emergentagent.com/job_design-portfolio-321/artifacts/izgr83ia_IMG_0641.jpeg',
      driveLink: 'https://drive.google.com/drive/folders/1EZQv-dYDbyn_W_Ls7i9PISnNx4iEO2M8',
      description: 'Modern commercial office with sophisticated branding and elegant interiors'
    },
    {
      name: 'Kalyani Motors',
      type: 'Automotive Showroom',
      location: 'Mysuru',
      image: 'https://customer-assets.emergentagent.com/job_design-portfolio-321/artifacts/gkiem7vx_67436BE1-8F4E-48BB-A183-9CAAC4CB83FE_1_105_c.jpeg',
      driveLink: 'https://drive.google.com/drive/folders/11eBBu0WVNbldxgyYwEwz8a-jwv3LWbIv',
      description: 'Premium automotive showroom featuring contemporary design and functional elegance. Successfully completed more than 15+ showrooms for Kalyani Motors'
    },
    {
      name: 'Quikr Project',
      type: 'Modern Office Lobby',
      location: 'Bangalore',
      image: 'https://customer-assets.emergentagent.com/job_design-portfolio-321/artifacts/q4yrm6ro_5F46ACAD-86A1-4EC8-BACF-59CD5A9965BA_1_105_c.jpeg',
      driveLink: 'https://drive.google.com/drive/folders/15WLGeu3-xHyopgxQmsCi_JBKgNm6hbo4?usp=sharing',
      description: 'Contemporary office space with bold branding and open-plan design'
    },
    {
      name: 'INTL SOS Mumbai',
      type: 'Commercial Office',
      location: 'Mumbai',
      image: 'https://customer-assets.emergentagent.com/job_design-portfolio-321/artifacts/5tnohxv0_Pintl.%20sos-mumbai.jpg',
      driveLink: 'https://drive.google.com/drive/folders/1_A5ztfbN6G2O7zZM3_vzWhxdmzsPk0iX?usp=sharing',
      description: 'Professional office interiors for international healthcare and security services company'
    },
    {
      name: 'Shantiniketan Mall',
      type: 'Commercial Mall',
      location: 'Bangalore',
      image: 'https://customer-assets.emergentagent.com/job_design-portfolio-321/artifacts/fy0yvuq0_exterior1.jpg',
      driveLink: '#',
      description: 'Comprehensive civil work and interior design for commercial retail space'
    }
  ];

  return (
    <section id="portfolio" className="py-24 px-6 bg-[#111113]">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <p className="text-[#FF8C42] text-sm tracking-[0.3em] uppercase mb-4">Our Work</p>
          <h2
            className="text-4xl md:text-5xl font-serif text-white mb-6"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Featured Projects
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Explore our portfolio of completed projects showcasing excellence in design and execution
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <div
              key={index}
              className="group relative bg-[#1a1a1c] rounded-sm overflow-hidden hover:shadow-2xl hover:shadow-[#FF8C42]/10 transition-all duration-500"
              style={{
                animation: `fadeInUp 0.8s ease-out ${index * 0.1}s both`
              }}
            >
              {/* Project Image */}
              <div className="relative h-80 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0c] via-transparent to-transparent opacity-80" />

                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-[#FF8C42]/0 group-hover:bg-[#FF8C42]/20 transition-all duration-500" />
              </div>

              {/* Project Info */}
              <div className="relative p-8">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3
                      className="text-2xl font-serif text-white mb-2 group-hover:text-[#FF8C42] transition-colors"
                      style={{ fontFamily: 'Playfair Display, serif' }}
                    >
                      {project.name}
                    </h3>
                    <p className="text-[#FF8C42] text-sm tracking-wide">{project.type}</p>
                    <p className="text-white/50 text-sm mt-1">{project.location}</p>
                  </div>
                </div>

                <p className="text-white/70 text-sm leading-relaxed mb-6">{project.description}</p>

                {/* View Project Button */}
                <button
                  onClick={() => openProjectModal(project)}
                  className="inline-flex items-center gap-2 text-[#FF8C42] hover:text-[#ff9d5c] transition-colors group/link cursor-pointer"
                >
                  <span className="text-sm tracking-wide">View Full Project</span>
                  <ArrowUpRight size={18} className="transition-transform group-hover/link:translate-x-1 group-hover/link:-translate-y-1" />
                </button>
              </div>

              {/* Corner Accent */}
              <div className="absolute top-0 right-0 w-20 h-20 border-t-2 border-r-2 border-[#FF8C42]/0 group-hover:border-[#FF8C42]/50 transition-all duration-500" />
            </div>
          ))}
        </div>
      </div>

      {/* Project Modal */}
      {selectedProject && (
        <ProjectModal
          project={selectedProject}
          isOpen={isModalOpen}
          onClose={closeModal}
        />
      )}

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default Portfolio;